import { ROUTES } from '@/constants';
import Button from '@/components/Button';

function ErrorPage({
  title = 'Something went wrong',
  message = 'An unexpected error occurred. Please try again.',
  onRetry,
}) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-6 bg-gray-50">
      <h1 className="text-4xl font-bold text-red-600 mb-2">{title}</h1>
      <p className="text-gray-600 max-w-md">{message}</p>
      <div className="flex gap-3 mt-8">
        {onRetry && (
          <Button variant="secondary" onClick={onRetry}>
            Try Again
          </Button>
        )}
        <Button onClick={() => { window.location.href = ROUTES.HOME; }}>
          Back to Home
        </Button>
      </div>
    </div>
  );
}

export default ErrorPage;
